import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function BankDetailSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default BankDetailSkeleton;
